import { Outlet } from 'react-router';

export default function Sandbox() {
    return <Outlet />;
}
